import type {VendorProItem} from 'store/slices/vendor-pro/types';

import {dateToReadableDate} from '@date-picker';
import {Loading} from '@ds/components';
import InfiniteScroll from 'react-infinite-scroll-component';
import {useNavigate} from 'react-router-dom';

import {PRO_ROUTES} from '../../../constants';
import ProHistoryItem from './components/ProHistoryItem/ProHistoryItem';

type ProHistoryListProps = {
  items: VendorProItem[];
  totalItems: number;
  onLoadMore: () => void;
};

const ProHistoryList: React.FC<ProHistoryListProps> = ({items, totalItems, onLoadMore}) => {
  const navigate = useNavigate();

  return (
    <InfiniteScroll
      next={onLoadMore}
      dataLength={items.length}
      scrollableTarget="pro-history-list"
      hasMore={items.length < totalItems}
      loader={
        <div className="flex h-10 justify-center">
          <Loading size="medium" color="primary" />
        </div>
      }
      scrollThreshold={0.6}
    >
      {items.map((item, index) => (
        <ProHistoryItem
          key={item.id}
          subtitle={dateToReadableDate({
            date: item.start_date,
            day: true,
            month: true
          })}
          state={item.state}
          noBorder={index === items.length - 1}
          onClick={() =>
            navigate(PRO_ROUTES.details.replace(':vendorProId', String(item.id)))
          }
        />
      ))}
    </InfiniteScroll>
  );
};

export default ProHistoryList;
